export const accountFields = {
  firstname: { type: 'string', description: 'First name.' },
  lastname: { type: 'string', description: 'Last name.' },
  email: { type: 'string', description: 'Login email address. Must be unique.' },
  password: {
    type: 'string',
    description:
      'Login password. Write-only — never read back into context. Required when creating a new account; ' +
      'leave unset when editing to keep the existing password.',
  },
  is_admin: { type: 'boolean', description: 'Whether this account is a customer admin. Only admins can change this.' },
  is_active: { type: 'boolean', description: 'Whether this account can sign in. Defaults to true on create.' },
};
